import React, {useEffect, useState} from "react";
import styles from "./Tabs.module.scss";

const Tabs = ({ tabsList, handleActiveTab, active }) => {

  const [activeTab, setActiveTab] = useState({[tabsList[0].id]: true});

  const handleOnChange = (param) => {
    if (!activeTab[param]) {
      setActiveTab(prevState => ({ [ param ]: !prevState[ param ] }));
    }
  }

  useEffect(() => {
    handleActiveTab(activeTab);
  }, [activeTab])

  useEffect(() => {
    if (active) {
      setActiveTab(active);
    }
  }, []);

  return (
    <ul className={`${styles.Tabs} d-flex align-items-center justify-content-between`}>
      {
        tabsList.map(tab => (
          <li
            onClick={() => handleOnChange(tab.id)}
            className={`d-flex align-items-center ${styles.tab} ${styles.Tab} ${activeTab[tab.id] ? styles.active : ''}`}
            style={{width: `${100 / tabsList.length}%`}}
          >
            <div className={'d-flex align-items-center ml-2'}>
              <div className={'d-flex'}>
                { tab.icon }
              </div>
              <div className={'ml-2'}>
                { tab.title }
              </div>
            </div>
          </li>
        ))
      }
      <li style={{width: `${100 / tabsList.length}%`, left: `calc(${100 / tabsList.length}% - 4px)`}} className={`${styles.presentationSlider}`} role="presentation"> </li>
    </ul>
  )
}

export default Tabs;